import InternetExplorerSupportBannerApp from "./InternetExplorerSupportBannerApp";

export { InternetExplorerSupportBannerApp as default };
